/** 协议 §5.6.1：*_updateable 为目标版本号字符串；已最新为 "" */

import { amplifierI18nService } from '../../i18n/amplifier/amplifierI18nService';

/** 解析 remote_control 中的可更新版本字段（兼容旧固件误发 boolean） */
export function parseUpdateableVersion(raw: unknown): string {
  if (typeof raw === 'string') return raw.trim();
  if (raw === true) return amplifierI18nService.t('可更新');
  return '';
}

/** 是否存在待更新版本（非空且与当前版本不同） */
export function hasPendingUpdate(currentVersion: string, updateableVersion: string): boolean {
  const target = updateableVersion.trim();
  if (!target) return false;
  const updateAvailableLabel = amplifierI18nService.t('可更新');
  if (target === updateAvailableLabel || target === '可更新') return true;
  const current = currentVersion.trim();
  if (!current) return true;
  return target !== current;
}

/** 版本行展示：当前版本 + 可选目标版本箭头 */
export function formatVersionWithUpdateHint(
  currentVersion: string | number | null | undefined,
  updateableVersion: string,
): string {
  const current = currentVersion == null || currentVersion === '' ? '—' : String(currentVersion);
  const target = updateableVersion.trim();
  if (!target) return current;
  return `${current} → ${target}`;
}
